const setSwiper = (selector, type, pagination) => {
  if (type === 'blog') {
    new Swiper(selector, {
      loop: true,
      simulateTouch: true,
      breakpoints: {
        1441: {
          slidesPerView: 3,
          spaceBetween: 15,
        },
        769: {
          slidesPerView: 2,
          spaceBetween: 10,
        },
        480: {
          slidesPerView: 1.3,
          spaceBetween: 10,
        },
        420: {
          slidesPerView: 1.2,
          spaceBetween: 10,
        },
        361: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: false,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true,
        },
      },
      pagination: {
        el: '.' + pagination + '-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.' + pagination + '-button-prev',
        prevEl: '.' + pagination + '-button-next',
        disabledClass: 'last',
      },
    });
  } else if (type === 'news') {
    new Swiper(selector, {
      loop: true,
      simulateTouch: true,
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 10,
          centeredSlides: false,
        },
        601: {
          slidesPerView: 2,
          spaceBetween: 10,
          centeredSlides: false,
        },
        480: {
          slidesPerView: 1.3,
          spaceBetween: 10,
          centeredSlides: false,
        },
        421: {
          slidesPerView: 1.2,
          spaceBetween: 10,
          centeredSlides: false,
        },
        361: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: false,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true,
        },
      },
      pagination: {
        el: '.' + pagination + '-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.' + pagination + '-button-prev',
        prevEl: '.' + pagination + '-button-next',
        disabledClass: 'last',
      },
    });
  } else if (type === 'publication') {
    new Swiper(selector, {
      simulateTouch: true,
      breakpoints: {
        1025: {
          slidesPerView: 3,
          spaceBetween: 15,
          centeredSlides: false,
        },
        769: {
          slidesPerView: 2,
          spaceBetween: 15,
          centeredSlides: false,
        },
        480: {
          slidesPerView: 1.3,
          spaceBetween: 15,
          centeredSlides: false,
        },
        421: {
          slidesPerView: 1.2,
          spaceBetween: 10,
          centeredSlides: false,
        },
        361: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: false,
        },
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true,
        },
      },
      pagination: {
        el: '.' + pagination + '-pagination',
        type: 'fraction',
      },
      navigation: {
        nextEl: '.' + pagination + '-button-prev',
        prevEl: '.' + pagination + '-button-next',
        disabledClass: 'last',
      },
    });
  } else if (type === 'testi') {
    new Swiper(selector, {
      loop: true,
      simulateTouch: true,
      breakpoints: {
        320: {
          slidesPerView: 1,
          spaceBetween: 10,
          centeredSlides: true,
        },
      },
      pagination: {
        el: '.' + pagination + '-pagination',
        clickable: true,
        bulletActiveClass: 'activePagination',
      },
      navigation: {
        nextEl: '.' + pagination + '-button-prev',
        prevEl: '.' + pagination + '-button-next',
        disabledClass: 'last',
      },
    });
  } else if (type === 'cases') {
    let infoBlocks = document.querySelectorAll('.cases-info'),
      chips = document.querySelectorAll('.cases-block'),
      navigation = document.querySelector('.cases-navigation'),
      swiper = null;

    function initCasesSwiper() {
      if (!swiper) {
        swiper = new Swiper(selector, {
          height: 163,
          breakpoints: {
            1025: {
              direction: 'vertical',
              spaceBetween: 20,
              slidesPerView: 1,
            },
            769: {
              spaceBetween: 10,
              slidesPerView: 3,
            },
            320: {
              spaceBetween: 10,
              slidesPerView: 1.6,
            },
          },

          navigation: {
            nextEl: '.' + pagination + '-button-prev',
            prevEl: '.' + pagination + '-button-next',
            disabledClass: 'last',
          },
          on: {
            init: function () {
              changeClickSlide();
            },

            activeIndexChange: function () {
              changeSlide(this.activeIndex);
            },
          },
        });
      }
    }

    //Гибкий рендеринг слайдера при ресайзе экрана
    initCasesSwiper();

    function destroy() {
      if (swiper) {
        swiper.destroy();
        swiper = null;
      }
    }
    window.addEventListener('orientationchange', () => {
      setTimeout(() => {
        destroy();
        initCasesSwiper();
      }, 1000);
    });

    //Смена контента информационного блока, при смене слайда
    function changeSlide(index) {
      [...chips].forEach((item, idx) => {
        item.classList.remove('active-slide');
        item.style.background = 'initial';
        item.style.borderColor = 'initial';
    
        if (idx === index) {
          item.classList.add('active-slide');
          item.style.background = colorActiveSlideCases;
          item.style.borderColor = colorActiveSlideCases;
        } 
      });
    
      [...infoBlocks].map((item, idx) => {
        item.classList.remove('active');
        if (idx === index) {
          item.classList.add('active');
        }
      });
    }

    //Смена контента информационного блока, при клике на слайд
    function changeClickSlide() {
      [...chips][0].classList.add('active-slide');
      [...chips][0].style.background = colorActiveSlideCases;
      [...chips][0].style.borderColor = colorActiveSlideCases;

      [...infoBlocks][0].classList.add('active');
      [...chips].length > 4 ? (navigation.style.display = 'flex') : '';
      [...chips].forEach((item, idx) => {
        item.addEventListener('click', (e) => {
          [...chips].map((it) => {
            it.classList.remove('active-slide');
            it.style.background = 'initial';
            it.style.borderColor = 'initial';
          });
          item.classList.add('active-slide');
          item.style.background = colorActiveSlideCases;
          item.style.borderColor = colorActiveSlideCases;

          [...infoBlocks].map((it) => {
            it.classList.remove('active');
            [...infoBlocks][idx].classList.add('active');
          });
        });
      });
    }
  } else if (type === 'prices') {
    new Swiper(selector, {
      breakpoints: {
        320: {
          slidesPerView: 1.02,
          spaceBetween: 20,
          centeredSlides: true,
        },
      },
      pagination: {
        el: '.' + pagination + '-pagination',
        clickable: true,
        bulletActiveClass: 'activePagination',
      },
    });
  }
};

export default setSwiper;
